import React from 'react';
import { UsersIcon, BookOpenIcon, StarIcon, MapPinIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-brand-dark text-white py-10 px-4" data-id="element-267">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-268">
        <div className="flex flex-col items-center justify-center" data-id="element-269">
          <UsersIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-270" />
          <span className="text-3xl font-black mb-1" data-id="element-271">+500</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-272">
            profesionales
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-273">
          <BookOpenIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-274" />
          <span className="text-3xl font-black mb-1" data-id="element-275">52</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-276">
            Cursos listos
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-277">
          <div className="flex text-yellow-400 mb-3" data-id="element-278">
            <StarIcon className="w-8 h-8 fill-current" data-id="element-279" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-280" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-281" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-282" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-283" />
          </div>
          <span className="text-3xl font-black mb-1" data-id="element-284">4.9/5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-285">
            calificación
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-286">
          <MapPinIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-287" />
          <span className="text-3xl font-black mb-1" data-id="element-288">🇦🇷</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-289">
            Todo el país
            <br data-id="element-290" />
            ingeniería y técnicos
          </span>
        </div>
      </div>
    </section>;
}